/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    MotorFaqQuestion1: {
        id: 'cep.components.sgHelpDialog.spm.faqQuestion1',
        defaultMessage: 'How do I renew my policy?'
    },
    MotorFaqAnswer1: {
        id: 'cep.components.sgHelpDialog.spm.faqAnswer1',
        defaultMessage: 'You will be sent a renewal invitation at least 21 days before your renewal date. Your renewal invitation will then also be available for you to review and renew for home and motor policies on MySaga. If you pay by Direct Debit or set up a continuous payment when you took out your policy, don’t worry we will automatically renew it for you.'
    },
    MotorFaqQuestion2: {
        id: 'cep.components.sgHelpDialog.spm.faqQuestion2',
        defaultMessage: 'Cancellation - after the first 14 days'
    },
    MotorFaqAnswer2: {
        id: 'cep.components.sgHelpDialog.spm.faqAnswer2',
        defaultMessage: 'After the 14-days, you can choose to cancel your car insurance at any time. A £50 cancellation charge may be applied if you cancel midway through your policy term. If you have a Saga Plus policy there will be no admin or cancellation fees to pay if you choose to cancel. The arrangement fee is non-refundable if your cover has already started. You will receive a pro-rata refund for your insurance policy if no claim has been made.'
    },
    MotorFaqQuestion3: {
        id: 'cep.components.sgHelpDialog.spm.faqQuestion3',
        defaultMessage: 'How do I change my vehicle?'
    },
    MotorFaqAnswer3_1: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_1',
        defaultMessage: 'You can change your car by visiting &lt;a href="https://www.saga.co.uk/mysaga/manage-policy/html/" target="_blank"&gt;MySaga&lt;/a&gt;.'
    },
    MotorFaqAnswer3_2: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_2',
        defaultMessage: 'You will need to provide the following:'
    },
    MotorFaqAnswer3_3: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_3',
        defaultMessage: 'Car reg number'
    },
    MotorFaqAnswer3_4: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_4',
        defaultMessage: 'Make/Model/Description'
    },
    MotorFaqAnswer3_5: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_5',
        defaultMessage: 'Engine size (cc)'
    },
    MotorFaqAnswer3_6: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_6',
        defaultMessage: 'Year of manufacture'
    },
    MotorFaqAnswer3_7: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_7',
        defaultMessage: 'Vehicle value'
    },
    MotorFaqAnswer3_8: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_8',
        defaultMessage: 'Any modifications'
    },
    MotorFaqAnswer3_9: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_9',
        defaultMessage: 'Where the vehicle is kept overnight.'
    },
    MotorFaqAnswer3_10: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_10',
        defaultMessage: 'You will also have the opportunity to check the level of cover needed and that the annual mileage is appropriate for your everyday needs.'
    },
    MotorFaqAnswer3_11: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_11',
        defaultMessage: 'If you have Saga Breakdown Assistance, we\'ll update this too so this can be applied to the new car.'
    },
    MotorFaqAnswer3_12: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_12',
        defaultMessage: 'We won\'t charge you an admin fee if you change your car but the price of your insurance may change.'
    },
    MotorFaqAnswer3_13: {
        id: 'cep.faqPage.generalSection.topics.MotorFaqAnswer3_13',
        defaultMessage: 'Don\'t forget that when you change your car you\'ll need to tax it before you can legally drive it on the road. You can &lt;a href="https://www.gov.uk/vehicle-tax" target="_blank"&gt;do this online&lt;/a&gt;'
    },
    HomeFaqQuestion1: {
        id: 'cep.components.sgHelpDialog.sph.faqQuestion1',
        defaultMessage: 'Cancellation - Before the policy has started.'
    },
    HomeFaqAnswer1: {
        id: 'cep.components.sgHelpDialog.sph.faqAnswer1',
        defaultMessage: 'If you wish to cancel your policy after receiving your documents but before your policy has started, you will receive a full refund of the premium paid.'
    },
    HomeFaqQuestion2: {
        id: 'cep.components.sgHelpDialog.sph.faqQuestion2',
        defaultMessage: 'How long is No Claim Discount valid for?'
    },
    HomeFaqAnswer2: {
        id: 'cep.components.sgHelpDialog.sph.faqAnswer2',
        defaultMessage: 'Your NCD will be valid for two years after the end of your last policy, provided it is not being used on another policy.'
    },
    HomeFaqQuestion3: {
        id: 'cep.components.sgHelpDialog.sph.faqQuestion3',
        defaultMessage: 'How do I access my policy documents?'
    },
    HomeFaqAnswer3: {
        id: 'cep.components.sgHelpDialog.sph.faqAnswer3',
        defaultMessage: 'You can access your policy documents in the {documentsLink} section of MySaga. You can also request copies of these documents by post. If the documents don\'t arrive, or if you previously asked for an alternative format like large print, audio or braille and this isn\'t provided, please give us a call on {homePhoneNumber} (for Home Insurance) or {motorPhoneNumber} (for Motor Insurance), or contact us using the Chat button on our website.'
    },
    Documents: {
        id: 'cep.components.sgHelpDialog.Documents',
        defaultMessage: 'Documents'
    },
    FaqHeader: {
        id: 'cep.components.sgHelpDialog.FaqHeader',
        defaultMessage: 'Frequently Asked Questions (FAQ)'
    },
    FaqButton: {
        id: 'cep.components.sgHelpDialog.FaqButton',
        defaultMessage: 'FAQ'
    },
    MoreFaqsButton: {
        id: 'cep.components.sgHelpDialog.MoreFaqsButton',
        defaultMessage: 'More FAQs'
    },
    ChatWithUs: {
        id: 'cep.components.sgHelpDialog.ChatWithUs',
        defaultMessage: 'Chat with a member of our team'
    },
    LeaveMessage: {
        id: 'cep.components.sgHelpDialog.LeaveMessage',
        defaultMessage: 'Leave a message'
    },
    ConsultantWillContactYou: {
        id: 'cep.components.sgHelpDialog.ConsultantWillContactYou',
        defaultMessage: '... and one of our Consultants will contact you during our working hours.'
    },
    ChatNow: {
        id: 'cep.components.sgHelpDialog.ChatNow',
        defaultMessage: 'Chat now'
    },
    MessageUs: {
        id: 'cep.components.sgHelpDialog.MessageUs',
        defaultMessage: 'Message us'
    },
    TalkToTeamMember: {
        id: 'cep.components.sgHelpDialog.TalkToTeamMember',
        defaultMessage: 'Talk to a member of our team'
    },
    OurLinesAreOpen: {
        id: 'cep.components.sgHelpDialog.OurLinesAreOpen',
        defaultMessage: 'Our lines are open:'
    },
    OpenWeekdays: {
        id: 'cep.components.sgHelpDialog.OpenWeekdays',
        defaultMessage: '8.30am to 8pm weekdays'
    },
    OpenSaturday: {
        id: 'cep.components.sgHelpDialog.OpenSaturday',
        defaultMessage: '8:30am to 5pm Saturday'
    },
    OpenSunday: {
        id: 'cep.components.sgHelpDialog.OpenSunday',
        defaultMessage: '9am to 5pm Sunday'
    },
    CallUs: {
        id: 'cep.components.sgHelpDialog.CallUs',
        defaultMessage: 'Call us'
    },
    CarInsurance: {
        id: 'cep.components.sgHelpDialog.CarInsurance',
        defaultMessage: 'Car Insurance'
    },
    HomeInsurance: {
        id: 'cep.components.sgHelpDialog.HomeInsurance',
        defaultMessage: 'Home Insurance'
    },
    PopularFaqs: {
        id: 'cep.components.sgHelpDialog.PopularFaqs',
        defaultMessage: 'Popular FAQs'
    },
    Close: {
        id: 'cep.components.sgHelpDialog.Close',
        defaultMessage: 'Close'
    },
    Help: {
        id: 'cep.components.sgHelpDialog.Help',
        defaultMessage: 'Help'
    },
    NeedToContactUs: {
        id: 'cep.components.sgHelpDialog.NeedToContactUs',
        defaultMessage: 'Need to contact us?'
    },
    ChatOpenMobile: {
        id: 'cep.components.sgHelpDialog.ChatOpenMobile',
        defaultMessage: 'Chat now'
    },
    MessageUsMobile: {
        id: 'cep.components.sgHelpDialog.MessageUsMobile',
        defaultMessage: 'Message us'
    }
});
